module.exports = __webpack_public_path__ + "img/goup.357aa556.svg";